import React, { useRef } from "react";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { CaretRight, CaretLeft } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

const PastCourses = ({ data }) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  console.log(data);
  return (
    <section className="mt-secondary lg:mt-primary  relative overflow-hidden">
      <h2 className="text-3xl text-white uppercase font-semibold mb-6">
        Past Trainings / Workshops
      </h2>
      <div className=" absolute z-[1000] left-0 top-1/2 -translate-y-1/2 gap-x-2 mb-4">
        <button
          ref={prevRef}
          className=" z-[100]  flex items-center justify-center bg-black text-3xl text-font p-2 border border-font "
        >
          <CaretLeft />
        </button>
        <button
          ref={nextRef}
          className=" z-[100]  flex items-center justify-center bg-black text-3xl text-font p-2 border border-font "
        >
          <CaretRight />
        </button>
      </div>
      <Swiper
        spaceBetween={10}
        slidesPerView={1}
        slidesPerGroup={1}
        navigation={{
          clickable: true,
          prevEl: prevRef.current,
          nextEl: nextRef.current,
        }}
        onBeforeInit={(swiper) => {
          swiper.params.navigation.prevEl = prevRef.current;
          swiper.params.navigation.nextEl = nextRef.current;
        }}
        breakpoints={{
          768: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          992: {
            slidesPerView: 2.5,
            slidesPerGroup: 2,
          },
        }}
        modules={[Autoplay, Navigation]}
        className="w-full"
        speed={1000}
      >
        {data?.map(
          ({ course_title, course_image, course_date, slug }, index) => (
            <SwiperSlide key={index} className="w-full flex justify-center">
              <Link to={`/academy/past_courses/${slug}`} className="w-full ">
                <img
                  className="w-full h-[350px] object-cover"
                  src={course_image}
                  alt={course_title}
                />
                <p className="my-2 text-lg text-font">{course_date}</p>
                <p className="text-2xl capitalize text-white w-3/4">
                  {course_title}
                </p>
              </Link>
            </SwiperSlide>
          )
        )}
      </Swiper>
    </section>
  );
};

export default PastCourses;
